<template>
  <div>
    <div v-if="showR">
      <MonthlyReport
        v-for="(item, index) of selectedCourses"
        :key="index"
        :teacherId="teacherData.id"
        :courseId="item.id"
        :courseName="item.name"
        :dateFrom="
          reportsDownload.isPendingReport
            ? startOfMonth
            : reportsDownload.initialDateToReport
        "
        :dateTo="
          reportsDownload.isPendingReport
            ? endOfMonth
            : reportsDownload.finalDateToReport
        "
      ></MonthlyReport>
    </div>
    <OffCanvas />
    <div :class="classContainer">
      <Navbar />
      <div class="off-canvas-wrapper kal-dashboard elevation-1">
        <div class="off-canvas-wrapper-inner" data-off-canvas-wrapper>
          <Sidemenu />

          <div class="off-canvas-content" data-off-canvas-content>
            <router-view />
          </div>
        </div>
      </div>
    </div>
    <SchoolModal @close="showModal = false" v-if="showModal"></SchoolModal>
    <TeacherDayModal
      @close="showModalTeacherDay = false"
      v-if="showModalTeacherDay"
    ></TeacherDayModal>
    <MonthlyModal
      @close="showMonthlyModal = false"
      @showReport="showReport"
      v-if="showMonthlyModal"
    ></MonthlyModal>
    <MonthlyReportsModal
      SchoolModal
      @close="showReportModal = false"
      v-if="showReportModal"
    ></MonthlyReportsModal>
    <CoursesWithoutBook
      @close="showCoursesWithoutBook = false"
      v-if="showCoursesWithoutBook"
      :coursesWithoutBookIds="coursesWithoutBookIds"
    ></CoursesWithoutBook>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Navbar from "@/components/Navbar";
import Sidemenu from "@/components/Sidemenu";
import OffCanvas from "@/components/Offcanvas";
import SchoolModal from "@/components/SchoolModal";
import TeacherDayModal from "@/components/TeacherDayModal";
import MonthlyModal from "@/components/MonthlyModal";
import MonthlyReportsModal from "@/components/userProfile/MonthlyReportsModal";
import CoursesWithoutBook from "@/components/CoursesWithoutBook";
import MonthlyReport from "./report/MonthlyReport";

export default {
  name: "dashboard",
  components: {
    Navbar,
    Sidemenu,
    OffCanvas,
    SchoolModal,
    MonthlyModal,
    MonthlyReportsModal,
    MonthlyReport,
    CoursesWithoutBook,
    TeacherDayModal,
  },
  computed: {
    ...mapState([
      "teacherData",
      "dataUrl",
      "tour1",
      "ownerSchoolSelected",
      "showR",
      "userData",
      "selectedCourses",
      "reportsDownload",
      "showCoursesWithoutBooks",
    ]),
  },
  data() {
    return {
      ad: true,
      classContainer: "",
      showModal: false,
      showMonthlyModal: false,
      showReportModal: false,
      startOfMonth: null,
      endOfMonth: null,
      showCoursesWithoutBook: false,
      showModalTeacherDay: false,
      coursesWithoutBookIds: [],
    };
  },
  methods: {
    ...mapMutations([
      "setUserData",
      "setCourseList",
      "setTour1",
      "setQuantityPendingReport",
      "setShowCoursesWithoutBooks",
      "setTeacherData",
      "setToken",
    ]),
    async setAuthentication() {
      if (!this.$route.query.token) return;

      this.setToken(this.$route.query.token);

      try {
        const { data } = await this.axios.post(`${this.dataUrl}/token`);
        if (data.status.code === 1 && data.content) {
          this.setTeacherData({
            teacherId: data.content.user.id,
            token: this.$route.query.token,
          });
          this.$store.dispatch("login", { axios: this.axios });
          this.$router.push("/dashboard/analytics");
        } else {
          throw new Error("Autenticación fallida");
        }
      } catch (error) {
        console.error("Error al autenticar", error);
      }
      return;
    },
    showReport() {
      // LOGICA DE BACK
      this.showMonthlyModal = false;
      this.showReportModal = true;
    },
    async getUserData() {
      await this.setAuthentication();
      let loader = this.$loading.show();

      let user = await this.$getUserData(
        this.axios,
        this.dataUrl,
        this.teacherData.id
      );

      if (!user) {
        loader.hide();
        alert("No se pudo obtener la información del usuario");
        return;
      }

      if (this.showCoursesWithoutBooks) {
        this.coursesWithoutBookIds = user.courseIdsWithoutBook;
        this.showCoursesWithoutBook = this.coursesWithoutBookIds.length > 0;
        this.setShowCoursesWithoutBooks();
      }

      if (
        user.owner_school &&
        user.owner_school.length > 0 &&
        !this.ownerSchoolSelected
      ) {
        this.showModal = true;
      }

      // TEMPORAL
      if (
        (user.aux == 0 || !user.aux) &&
        user.school.baseCountryName == "CHILE"
      ) {
        this.showModalTeacherDay = true;
        user.aux = 1;
        await this.updateAux();
      }

      this.setUserData(user);
      if (user.pendingReportDTO.pendingReports.length > 0) {
        this.setQuantityPendingReport(
          user.pendingReportDTO.pendingReports.length
        );
      }
      this.setQuantityPendingReport(
        user.pendingReportDTO.pendingReports.length
      );

      if (user.numberSession < 2 && !this.tour1) {
        this.setTour1(true);
        this.$router.push("/dashboard/analytics?product_tour_id=121328");
      }

      let courses = await this.$getCourseList(this.axios, this.dataUrl, user);

      this.setCourseList(courses);

      user.pendingReportDTO.pendingReports.forEach(coursePending => {
        courses.forEach(course => {
          if (coursePending.id == course.id) {
            coursePending.name = course.name;
          }
        });
      });

      if (user.pendingReportDTO.showModal) {
        this.showMonthlyModal = true;
        this.updateFlagModal();
      }

      loader.hide();
    },
    async updateFlagModal() {
      try {
        let { data } = await this.axios.put(
          `${this.dataUrl}/monthlyReport/setShowModal/${this.teacherData.id}`
        );
        return data.content;
      } catch {
        // this.getUserData();
      } finally {
        // do something
      }
    },
    async updateAux() {
      try {
        let { data } = await this.axios.get(
          `${this.dataUrl}/bookUser/updateAux/?userId=${this.teacherData.id}`
        );
        return data.content;
      } catch {
        // this.getUserData();
      } finally {
        // do something
      }
    },
  },
  mounted() {
    if (this.$route.query.token !== "") this.getUserData();

    this.startOfMonth = this.$moment()
      .month(this.$moment().month() - 1)
      .startOf("month")
      .format("YYYY-MM-DD");
    this.endOfMonth = this.$moment()
      .month(this.$moment().month() - 1)
      .endOf("month")
      .format("YYYY-MM-DD");
    this.classContainer = this.ad ? "dashboard padding-ad" : "dashboard";
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  width: 90%;
}

.kal-dashboard {
  min-height: 100vh;
}

.off-canvas-content {
  padding-left: 15%;
  padding-right: 10px;
}

@media print, screen and (max-width: 64em) {
  .off-canvas-content {
    margin-left: 10vw;
    box-shadow: 0 -2px 18px 10px rgba(64, 64, 64, 0.2);
    padding-left: 10px;
  }
}

@media print, screen and (max-width: 576px) {
  .dashboard {
    width: 100%;
  }
  .off-canvas-content {
    margin-left: 0;
  }
}
.padding-ad {
  padding-top: 50px;
}
</style>
